import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { useTranslations } from 'next-intl';

import Pagination from '../pagination/pagination';
import TeaserContainerSkeleton from '../teaser-container/teaserContainer.skeleton';

import StyledFilterResults from './filterResults.style';
import Container from '../../layout/container/container';

import getPageModule from '../../utility/getPageModule';

export const FilterResults = ({
  isLoading = false,
  error = false,
  pageModules,
  filteredValues,
  pageType,
  pagination,
  time
}) => {
  const t = useTranslations();
  return (
    <StyledFilterResults isVisible={!isLoading} id="filter-results">
      {error && <div className="filter-results__error">{t('filter.error')}</div>}

      {/* Show loading skeleton */}
      {isLoading && (
        <div className="filter-results__loading">
          <TeaserContainerSkeleton />
          <TeaserContainerSkeleton />
          <TeaserContainerSkeleton />
        </div>
      )}

      {/* Check if pageModules array isnt empty else show no results message */}
      {!isLoading &&
        pageModules.length > 0 &&
        pageModules.map((block, index) => getPageModule(block, index)[block.type])}

      {!isLoading && pageModules.length === 0 && (
        <Container>
          <div className="filter-results__no-results">{t('filter.noResults')}</div>
        </Container>
      )}

      {pagination && pagination.total_pages > 1 && (
        <Pagination
          pageType={pageType}
          slug={pageType === 'index' ? null : time}
          filters={filteredValues}
          totalPages={parseInt(pagination.total_pages, 10)}
          currentPage={parseInt(pagination.current_page, 10)}
        />
      )}
    </StyledFilterResults>
  );
};

FilterResults.propTypes = {
  pageType: PropTypes.string,
  time: PropTypes.string.isRequired,
  pagination: PropTypes.shape(),
  filteredValues: PropTypes.arrayOf(PropTypes.string),
  isLoading: PropTypes.bool,
  error: PropTypes.bool,
  pageModules: PropTypes.arrayOf(PropTypes.shape())
};

const mapStateToProps = state => {
  const { filter, app } = state;
  return {
    filteredValues: filter.filteredValues,
    time: app.pageData.time,
    pagination: app.pageData.meta ? app.pageData.meta.pagination : null,
    pageModules: app.pageData.pageModules,
    isLoading: filter.isLoading,
    error: filter.error
  };
};

export default connect(mapStateToProps)(FilterResults);
